<template>
  <div class="chapters-list">
    <infinity-scroll
        :hasNextPage="canLoadMore"
        @scrolling="onLoadMore"
        :loading="loading"
    >
      <v-expansion-panels accordion>
        <v-expansion-panel
            v-for="(chapter, index) in list"
            :key="index"
        >
          <v-expansion-panel-header class="pl-6 pr-3">
            <v-btn
                class="chapter-button mr-4"
                @click.stop="onEditClick(chapter, index)"
                icon
                x-small
                color="primary"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>

            <!--
            <img
              @click.stop="onEditClick(chapter, index)"
              :src="getChapterImage(chapter)"
              alt="chapter-img"
              class="mr-4 chapter-img"
            />
            -->

            <div
                class="chapter-name-container"
                v-if="chapter"
            >
              <h4 class="chapter-name">
                <span v-if="isChapterHasQuestions(chapter)">
                  ({{ chapter.questions.length + chapter.videos.length + chapter.theory.length }})
                </span>
                <span>{{ chapter.name }}</span>
              </h4>

              <div class="description-text">{{ chapter.description }}</div>
              <div class="license-types">{{ chapter.licenseTypes }}</div>

              <div class="tenant-badges">
                <div class="tenant-badge tenant-wiki" v-if="chapter.is_wiki">Wiki</div>
                <div class="tenant-badge tenant-les" v-if="chapter.is_les">Les</div>
                <div class="tenant-badge tenant-online" v-if="chapter.is_online">Online</div>
              </div>
            </div>

            <div
                class="chapter-category mr-3 pl-3"
                v-if="chapter.category"
            >
              <v-btn x-small depressed color="primary" class="text-none">
                {{ getChapterCategoryName(chapter.category) }}
              </v-btn>
            </div>

            <statusButton
                :status="chapter.publicVisible"
                class="ml-a chapter-status mr-2"
            />
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />

            <v-expansion-panels accordion multiple>
              <v-expansion-panel
                  v-for="(questionType, index) in questionTypes"
                  :key="index"
              >
                <v-expansion-panel-header class="pl-6 pr-5">
                  {{ questionType.title }}
                  <span
                      class="pl-1"
                      v-show="chapter[questionType.query].length"
                  >
                    ({{ chapter[questionType.query].length }})
                  </span>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <v-divider />
                  <div>
                    <list
                        :list="chapter[questionType.query]"
                        :pagination="pagination"
                        preview-side="right"
                        defaultHeight="100%"
                        showMoveButtons
                        showTypeIcon
                        hideActions
                        showSelect
                        hideChapters
                        droppable
                        :headers="headers"
                        v-slot="{ item }"
                        @itemMoveDown="itemMoveDown($event, chapter, questionType.query)"
                        @itemMoveUp="itemMoveUp($event, chapter, questionType.query)"
                        @removeClicked="removeItemFromChapter($event, chapter, questionType.query)"
                        @on-drop="onDrop($event, chapter, questionType.query)"
                        :isToggleList="false"
                    />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </infinity-scroll>
  </div>
</template>

<script>
import {QUESTION_TYPES} from "../core/training-const";

export default {
  components: {
    list: () => import('./TrainingsList.vue'),
    infinityScroll: () => import('@/components/global/infinityScroll.vue'),
    statusButton: () => import('@/app/exercise/components/StatusButton'),
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    pagination: Object,
    loading: Boolean
  },
  computed: {
    canLoadMore() {
      if (this.pagination) {
        return !this.loading && this.pagination.count > this.list.length
      }
      return false;
    },
    questionTypes() {
      return Object.values(QUESTION_TYPES);
    },
  },
  watch: {
    pagination(val) {
      this.page = 1;
    },
  },
  data: () => ({
    headers: [
      { text: '', class: 'app-table__h_small' },
      // { text: 'ID', class: 'app-table__h_small' },
      { text: '', class: 'app-table__h_small' },
      { text: '', class: 'app-table__h_small' },
      { text: 'Short name' },
      { text: 'Category', align: 'center' },
      // { text: 'Layout' },
      { text: 'Section', align: 'center' },
    ],
    page: 1,
  }),
  methods: {
    getChapterImage(chapter) {
      return chapter.thumbnail ? chapter.thumbnail : require('@/assets/img/chapters/chapter-img.png');
    },
    getChapterCategoryName(categoryId) {
      if (categoryId === null || this.$store.state.chapterCategories.items === null) return '';
      const category = this.$store.state.chapterCategories.items.find(category => category.id === categoryId);
      return category ? category.name || '' : '';
    },
    isChapterHasQuestions(chapter) {
      return Boolean(chapter.questions.length) || Boolean(chapter.videos.length) || Boolean(chapter.theory.length);
    },
    onDrop({event, index}, chapter, questionType) {
      const item = event.dataTransfer.getData("item");
      const itemObject = JSON.parse(item);
      this.$emit('addItemToChapter', chapter, itemObject, questionType, index);
    },
    onEditClick(chapter, index) {
      this.$emit('onEditClick', chapter, index);
    },
    updateChapter(chapter) {
      this.$emit('updateChapter', chapter)
    },
    removeItemFromChapter(item, chapter, questionType) {
      this.$emit('removeItemFromChapter', chapter, item, questionType);
    },
    itemMoveDown(index, chapter, questionType) {
      chapter.moveItem('down', index, questionType);
      this.updateChapter(chapter)
    },
    itemMoveUp(index, chapter, questionType) {
      chapter.moveItem('up', index, questionType);
      this.updateChapter(chapter)
    },
    onLoadMore() {
      this.page += 1;
      this.$emit('loadMoreClick', this.page);
    },
  },
}
</script>
<style lang="scss" scoped>
.chapters-list {
  overflow-y: auto;
  height: calc(100vh - 56px - 64px - 64px + 10px);
}

.v-expansion-panel::v-deep{
  .v-expansion-panel.v-expansion-panel--active,
  &.v-expansion-panel--active{
    > .v-expansion-panel-header .v-expansion-panel-header__icon {
      .v-icon {
        transform: rotate(0deg);
      }
    }
  }
  .v-expansion-panel-header .v-expansion-panel-header__icon {
    .v-icon {
      transform: rotate(-90deg);
      color: $primary-color!important;
    }
  }
  .v-expansion-panel-content__wrap {
    padding: 0;
  }
}
.chapter-img {
  max-width: 40px;
  border-radius: 50%;
}
.chapter-status {
  flex: 0!important;
  pointer-events: none;
}
.chapter-name {
  white-space: nowrap;
  display: inline-block;
}
.chapter-name-container {
  overflow: hidden;
  text-overflow: ellipsis;
}
.chapter-button {
  flex: 0 1 auto!important;
  min-width: 22px;
  width: 22px;
}
.chapter-category::v-deep {
  pointer-events: none;
  text-align: right;
  .v-btn__content {
    max-width: 115px;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    text-overflow: ellipsis;
  }
}
.infinity-scroll__container ::v-deep {
  height: 100%;
  > div {
    height: 100%!important;
    overflow-y: auto!important;
  }
}

.license-types {
  font-size: 12px;
  color: #9e9e9e;
  margin-top: 4px;
}

.tenant-badges {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.tenant-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 4px;
  display: inline-block;

  &.tenant-wiki {
    background-color: #e3f2fd;
    color: #1976d2;
  }

  &.tenant-les {
    background-color: #f3e5f5;
    color: #7b1fa2;
  }

  &.tenant-online {
    background-color: #e8f5e8;
    color: #388e3c;
  }
}
</style>
